// ETODO Rename this whole thing to header message or something, talk with Jeremy
/* --- actions ---*/
const SET_HEADER_NOTIFICATION = 'SET_HEADER_NOTIFICATION';
const CLOSE_NOTIFICATIONS = 'CLOSE_NOTIFICATIONS';

/**
 * Opens a header message/notification
 * @param {Object} notification
 * @param {String} notification.message
 * @param {Object[]} [notification.buttons]
 * @param {String} notification.buttons.label
 * @param {func} notification.buttons.action
 * @param {func} [notification.backAction]
 * @return {function(*): *}
 * @private
 */
export const _setNotification = (notification) => dispatch => dispatch({type: SET_HEADER_NOTIFICATION, notification});
export const _removeNotification = (notification) => dispatch => dispatch({type: CLOSE_NOTIFICATIONS, notification});

/* --- reducer ---*/
export default function reducer(state = null, action) {
  switch (action.type) {
    case SET_HEADER_NOTIFICATION:
      return action.notification;
    case CLOSE_NOTIFICATIONS:
      return null;
    default:
      return state;
  }
}
